import React from 'react'
import type { Icon } from 'shared/utils'
import { colors } from 'app-v2/design-systems/theme'

export const CircleChecked = ({
    color = 'white',
    background = colors.crunchyGreen,
    size = 40,
    className = 'circle-checked',
    ...otherProps
}: Icon) => (
    <svg
        width={size}
        height={size}
        className={className}
        viewBox="0 0 40 40"
        {...otherProps}>
        <g fill="none" fillRule="evenodd">
            <rect width={40} height={40} fill={background} rx={20} />
            <path
                fill={color}
                d="M17.222 23.861L13.361 20l-1.315 1.306 5.176 5.175L28.333 15.37l-1.305-1.305z"
            />
        </g>
    </svg>
)
